import { useRequest } from "../../../app/hooks/useRequest";
import { getPresentingProblemsRequest } from "../PresentingProblemRequests";

export const useGetPresentingProblems = () =>
  useRequest(getPresentingProblemsRequest);
